/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CheckMicroAuthEligibilityRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'
import {CheckMicroAuthEligibilityResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'


export const checkMicroAuthEligibility = (request:CheckMicroAuthEligibilityRequest, options?: CashRequestOptions) => post<CheckMicroAuthEligibilityRequest, CheckMicroAuthEligibilityResponse>("/2.0/cash/check-micro-auth-eligibility", request, {...options, rejectOnError: true })